import Axios from "axios";

const updateSiteVisitReport = async (siteVisitId, values, token) =>
  await Axios.post(`${window.API}/site-visit/update/${siteVisitId}`, values, {
    headers: { Authorization: `Bearer ${token}` },
  });

export { updateSiteVisitReport };
